// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"587":"ab3dead6","621":"e7d96a7a"}[chunkId] + ".chunk.css";
};